import { useNavigate } from "react-router-dom";
import { maisIntegridade, mapa, sisbi } from "../../assets/images";
import {
  BannerText,
  BannerWrapper,
  BoxImageContainer,
  BoxImageMaisIntegridade,
  BoxImageMapa,
  BoxImageSisbi,
  BoxTextContainer,
  ButtonContatos,
  ContatosESelosContainer,
  DivImageRecipe,
  HomeContainer,
  InfoContainerUm,
  PImageRecipe,
} from "./styles";
import Footer from "../../components/footer";
import { receitas } from "../../constants/revenues";

const Revenues = () => {
  const navigate = useNavigate();

  return (
    <HomeContainer>
      <BannerWrapper>
        <BannerText>
          Receitas <br /> Suprema
        </BannerText>
      </BannerWrapper>

      <InfoContainerUm>
        {receitas.map((item, index) => (
          <DivImageRecipe
            key={index}
            imageUrl={item.image}
            onClick={() => navigate(`/revenues/${item.id}`)}
          >
            <PImageRecipe>{item.title}</PImageRecipe>
          </DivImageRecipe>
        ))}
      </InfoContainerUm>

      {/* Restante do seu código */}
      <ContatosESelosContainer>
        <BoxTextContainer>
          <div>
            <h2>Vamos fazer negócios?</h2>
            <p>Fale com um especialista</p>
          </div>
          <ButtonContatos
            onClick={() => {
              window.location.href = "/contact-us";
            }}
          >
            CONTATO
          </ButtonContatos>
        </BoxTextContainer>
        <BoxImageContainer>
          <BoxImageSisbi src={sisbi} alt="SISBI" />
          <BoxImageMaisIntegridade src={maisIntegridade} />
          <BoxImageMapa src={mapa} alt="Mapa" />
        </BoxImageContainer>
      </ContatosESelosContainer>
      <Footer />
    </HomeContainer>
  );
};

export default Revenues;
